<!--TODO: The file that equivalent of this file should be removed from ui-components-->
<template>
  <ShopProfileSkeleton v-if="loading" />
  <div v-else class="shop">
    <div class="shop_logo_box">
      <div class="shop_logo_box_image">
        <img :src="sellerLogo" />
      </div>
      <div class="shop_seller">
        <div class="seller_score_box">
          <h1 class="shop_seller_title">{{ sellerShop.storeName }}</h1>
          <div class="shop_seller_point">
            <div class="shop_title_wrapper">
              <div class="shop_score_wrapper">
                <span class="shop_score" :class="shopScoreColor">
                  {{ sellerShop?.sellerScore ? (parseFloat(sellerShop?.sellerScore) / 10) : '-' }}              
                </span>
                <template v-if="sellerShop?.sellerScore">
                  <span class="score_seperator">/</span>
                  <span class="shop_max_score">10.0</span>
                </template>
              </div>
            </div>
            <TooltipPlugin
              tooltipText="Mağaza Puanı hesaplaması için son 3 ayda en az 5 farklı üründen toplam 250 TL’lik satış yapmış olmanız gerekiyor. Tatil & Eğlence kategorisi ile Yatırımlık Altın kategorisindeki ürünler için puan hesaplaması yapılmaz."
              position="bottom-end"
              :tooltipWidth="250"
            >
              <template #tooltip-btn>
                <img src="@/assets/images/info.svg" />
              </template>
            </TooltipPlugin>
          </div>
        </div>
        <div class="shop_point_box">
          

      <div v-if="sellerShop.sellerScore">
        <div v-if="false" class="progress_bar">
          <div class="progress_bar_box">
            <div class="progress_bar_box_percent" :style="percent" />
          </div>
          <span class="progress_bar_box_percent_text"
            >%{{ sellerShop.sellerScore }}
          </span>
        </div>
        <!-- <span
          v-if="lowPointReasonCondition"
          class="reason-low-point"
          @click="accordion = !accordion"
        >
          Puanı Düşüren Nedenler
          <img class="accordion-arrow" src="@/assets/images/arrow-down.svg" />
        </span> -->
      </div>
        <div v-if="sellerShop.officialSeller" class="official_shop">
          <span>Yetkili Mağaza</span>
          <img class="official_shop_badge" src="@/assets/images/official.svg" alt="shop_badge" />
        </div>
        <Badge
          :isFastSellerBadgeActive="sellerShop.fastSellerBadge"
          :isTopSellerBadgeActive="sellerShop.topSellerBadge"
        />
      </div>
    </div>

    <div class="shop_dividers" />
      <div v-if="accordion" class="last_three_month">
        <div class="last_three_month_head">
          <img src="@/assets/images/calendar.svg" />
          <h1>Son 90 gün içerisinde…</h1>
        </div>

        <div class="last_three_month_list">
          <div class="last_three_month_list_item">
            <span class="last_three_month_list_item_text"> Geciken Kargo </span>
            <span class="last_three_month_list_item_badge">
              {{ sellerShop.lateShipmentCount }}
            </span>
          </div>
          <div class="last_three_month_list_item">
            <span class="last_three_month_list_item_text">
              Reddedilen Sipariş
            </span>
            <span class="last_three_month_list_item_badge">
              {{ sellerShop.rejectedItemCount }}
            </span>
          </div>
          <div class="last_three_month_list_item">
            <span class="last_three_month_list_item_text">
              Olumsuz Mağaza Yorumu
            </span>
            <span class="last_three_month_list_item_badge">
              {{ sellerShop.negativeCommentCount }}
            </span>
          </div>
          <span class="reason-low-point" @click="accordion = !accordion">
            Kapat
            <img class="accordion-arrow" src="@/assets/images/arrow-up.svg" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Badge from '@/components/ShopProfile/Badge';
import ShopProfileSkeleton from '@/components/ShopProfile/ShopProfileSkeleton';
import { TooltipPlugin } from '@n11/so-ui-components';

export default {
  name: 'ShopProfile',
  props: {
    sellerShop: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  components: {
    Badge,
    ShopProfileSkeleton,
    TooltipPlugin,
  },
  data() {
    return {
      accordion: false,
    };
  },
  computed: {
    sellerLogo() {
      return (
        this.sellerShop.logo ||
        'https://kurumsal.n11.com/assets/logo/logo-n11-ladybug-large.png'
      );
    },
    percent() {
      return {
        width: `${this.sellerShop.sellerScore}%`,
      };
    },
    lowPointReasonCondition() {
      return !this.accordion && this.sellerShop.sellerScore < 100;
    },
    shopScoreColor(){
      const score = parseFloat(this.sellerShop?.sellerScore) / 10;

      if (9 <= score && score <= 10) {
        return 'success60';
      } else if (7 <= score && score <= 8) {
        return 'success50';
      } else if (5 <= score && score <= 6) {
        return 'yellow50';
      } else if (3 <= score && score <= 4) {
        return 'yellow60';
      } else if (1 <= score && score <= 2) {
        return 'error50';
      } else {
        return 'success60';
      }
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';

.shop {
  max-width: 55%;
  border-radius: 8px;
  background-color: $colorN00;
  font-family: 'Open Sans', sans-serif !important;
  .shop_logo_box {
    display: flex;
    align-items: center;
    &_image {
      width: 64px;
      height: 64px;
      flex-shrink: 0;
      margin-right: 16px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 0.2px solid $colorN20;
        box-shadow: 0px 0.84px 1.68px 0px rgba(0, 0, 0, 0.25);
      }
    }
  }

  .shop_seller {
    width: calc(100% - 86px);
    display: flex;
    flex-direction: column;
    &_title {
      margin: 1px 0px 0px 0px;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.25;
      letter-spacing: -0.05px;
      color: $dark-gray-5;
      overflow: hidden;
      white-space: nowrap;
      max-width: 100%;
      text-overflow: ellipsis;
    }
    .shop_badges{
      position: static;
      margin: 4px 0 0;
    }

    .official_shop {
      display: flex;
      align-items: center;
      margin-top: 4px;
      font-size: 14px;
      font-weight: 600;
      color: $colorN60;

      &_badge {
        width: 18px;
        height: 18px;
        margin-left: 4px;
      }
    }
    .seller_score_box{
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 8px;
    }
  }

  &_dividers {
    max-width: 286px !important;
    height: 1px;
    margin: 11px 0 15px;
    background-color: $gray-1;
  }

  &_info {
    width: 18px;
    height: 16px;
    object-fit: contain;
    cursor: pointer;

    img {
      width: 16px;
      height: 16px;
    }
  }

  &_details {
    max-width: 286px !important;
    height: 40px;
    margin: 10px 0 0;
    padding: 11px 44px 11px 16px;
    border-radius: 4px;
    background-color: $yellow-4;

    p {
      width: 226px;
      height: 18px;
      font-size: 13px;
      font-weight: 600;
      color: $yellow-3;
    }
  }
}

.last_three_month {
  &_head {
    width: 286px;
    height: 40px;
    margin: 12px 0 14px 1px;
    padding: 8px 97px 8px 11px;
    border-radius: 4px;
    background-color: $yellow-4;
    display: flex;
  }

  h1 {
    width: 144px;
    height: 18px;
    margin: 3px 0 3px 10px;
    font-size: 13px;
    font-weight: 600;
    color: $yellow-3;
    line-height: normal;
  }

  &_list {
    &_item {
      padding: 10px 0 0;
      display: flex;
      justify-content: space-between;

      &_text {
        font-size: 14px;
        line-height: 1.29;
        letter-spacing: -0.05px;
        color: $dark-gray-5;
        margin-bottom: 8px;
      }

      &_badge {
        width: 30px;
        height: 20px;
        padding: 2px 8px;
        border-radius: 100px;
        background-color: $fair-pink;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.33;
        text-align: center;
        color: $cardinal;
      }

      &:after {
        content: '';
        width: 286px;
        height: 1px;
        margin: 25px 0 0;
        background-color: $gray-1;
        position: absolute;
      }
    }
  }
}

.progress_bar {
  display: flex;
  justify-content: space-between;

  &_box {
    background-color: $colorN10;
    width: 250px;
    height: 6px;
    margin: 10px 0 0;
    border-radius: 32px;
    display: inline-block;

    &_percent {
      background-color: $green-5;
      height: 6px;
      border-radius: 32px;

      &_text {
        width: 25px;
        height: 16px;
        margin: 4px 1px 0 0;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.33;
        color: $dark-gray-5;
      }
    }
  }
}

.reason-low-point {
  height: 18px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.38;
  color: $dark-gray-6;
  cursor: pointer;
  display: inline-block;
  margin-top: 13px;
  text-decoration: underline;
}

.accordion-arrow {
  position: absolute;
  margin-left: 4px;
}

.shop_seller_point {
  display: flex;
  justify-content: space-between;
  gap: 4px;

  .shop_title_wrapper {
    display: flex;
    align-items: center;
    gap: 4px;

    .shop_title {
      font-size: 14px;
    }

    .shop_score_wrapper {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 11px;
      font-weight: 700;

      .shop_score, .shop_max_score {
        color: white;
        padding: 2px 4px;
        border-radius: 4px;
      }

      .shop_score {
        &.success60 {
          background-color: $colorS60;
        }
        &.success50 {
          background-color: $colorS50;
        }
        &.yellow50 {
          background-color: $colorY50;
        }
        &.yellow60 {
          background-color: $colorY60;
        }
        &.error50 {
          background-color: $colorE50;
        }
      }

      .shop_max_score {
        background-color: $colorS60;
      }
    }
  }
}
</style>
